angular.module('theme').directive('campaignBannerCover', function ($window, $cookies, TrackerService) {
	return {
		restrict: 'A',
		scope: {
			id: '@campaignBannerCover',
			title: '<',
			track: '<',
			restrictions: '=',
			opacity: '@'
		},
		link: function ($scope, $element) {
			$scope.restricted = false;

			if ($scope.opacity) {
				$element.css('background-color', 'rgba(0,0,0,'+ $scope.opacity / 100 + ')');
			}

			var currentUrl = window.location.href;
			var closeBtn = angular.element($element[0].querySelectorAll('.campaign-banner-close'));
			var link = angular.element($element[0].querySelectorAll('.campaign-banner-cover-link'));

			_.each($scope.restrictions.split(', '), function(value) {
				if (currentUrl === value.replace('startsida/', '')) {
					$scope.restricted = true;
				}
			});

			if (!$cookies.get('hide-campaign-banner-cover-'+$scope.id) && (!$scope.restrictions || $scope.restricted)) {
				$element.addClass('d-block');

				if ($scope.track === 1) {
					var data = {
						'promoView': {
							'promotions': {
								'id': $scope.id,
								'name': $scope.title,
								'slot': 'Cover'
							}
						}
					};
	
					TrackerService.ecommerceEvent('promoView', data);
				}
			}

			closeBtn.bind('click', function(event) {
				event.preventDefault();

				$cookies.put('hide-campaign-banner-cover-' + $scope.id, true, {
					path: '/',
					expires: moment().add(1, 'month').toDate()
				});
				$element.removeClass('d-block');
			});

			link.bind('click', function(event) {
				event.preventDefault();

				var data = {
					'promoClick': {
						'promotions': {
							'id': $scope.id,
							'name': $scope.title,
							'slot': 'Cover'
						}
					}	
				};

				TrackerService.ecommerceEvent('promoClick', data);

				$cookies.put('hide-campaign-banner-cover-' + $scope.id, true, {
					path: '/',
					expires: moment().add(1, 'month').toDate()
				});

				if (event.target.href) {
					$window.location.href = event.target.href;
				}
			});
		}
	};
});
